import React from 'react';
import PropTypes from 'prop-types';

import HeroActionInfo from '../../PrincipalPaydown/components/Hero/HeroActionInfo';
import ListWithAction from '../../PrincipalPaydown/components/ListWithAction';

import invoice from '../../../assets/images/invoice.png';
import purchaseOrder from '../../../assets/images/purchase-order.png';
import {invoiceDocuments, purchaseOrderDocuments} from '../misc/tradeDocumentExamples';

const propTypes = {
  redirectTo: PropTypes.func.isRequired,
  trackClick: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const PreApprovalOnboarded = ({ redirectTo, trackClick, user}) => {

  const onActionClick = actionName => {
    if (actionName === 'invoices') trackClick('upload_invoice');
    if (actionName === 'purchase_orders') trackClick('upload_po');

    redirectTo(`/${actionName}/new`);
  }

  const infoText = () => {
    let base = '*Due to the COVID-19 situation, we will review applications on a case-to-case basis.';
    const kycSubmitted = user.onboarding.ptp_submitted && user.onboarding.btp_submitted
    const kycVerified = !!user.kyc_verified
    if(kycSubmitted && !kycVerified) {
      return base
    }
    return base + ' The amount we will finance can be higher or lower than this.';
  }

  return (
    <div className='ds-card' data-testid='pre-approval-onboarded'>
      <HeroActionInfo
        cardClassName='_borderBottom--medium'
        headerText="Submit for pre-approval now*"
        infoText={infoText()}
        infoClassName='_fontSize--small'
      />
      <div className='cardSection _verticalPadding--none _horizontalPadding--none _withColumns _justifyContent-center _alignItemsInitial'>
        <ListWithAction
          imageUrl={invoice}
          headline='Collect your unpaid invoices'
          subhead='Get paid up to 70% for any receivable'
          listHeader='We also accept:'
          listItems={invoiceDocuments}
          icon='check_circle'
          actionLabel='Upload an invoice'
          onActionClick={onActionClick.bind(this, 'invoices')}
          cardClassName='_borderRight--medium'
          buttonClassName='_marginTop--auto'
          dataTestId='upload-invoice-btn'
        />
        <ListWithAction
          imageUrl={purchaseOrder}
          headline='Take on more orders'
          subhead='Fund up to 60% for any unfulfilled order'
          listHeader='We also accept:'
          listItems={purchaseOrderDocuments}
          icon='check_circle'
          actionLabel='Upload a p.o.'
          onActionClick={onActionClick.bind(this, 'purchase_orders')}
          cardClassName='_displayFlex _flexColumn'
          buttonClassName='_marginTop--auto'
          dataTestId='upload-po-btn'
        />
      </div>
    </div>
  );
}

PreApprovalOnboarded.propTypes = propTypes;
export default PreApprovalOnboarded;



// WEBPACK FOOTER //
// ./src/features/applyNow/components/PreApprovalOnboarded.js